import { render } from "./index.vue?vue&type=template&id=3e67f912&bindings={}"
import script from "./Footer.js?vue&type=script&lang=js"
export * from "./Footer.js?vue&type=script&lang=js"

import "./Footer.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script